<template>
  <div class="mb-0 accordianheading">
    <div class="w100 m0" for="giftwrap">
      <div class="row">
        <div class="col-md-8 col-8">
          <div class="fsemibold f16">Gift wrap this order
            <small class="op_5 lightfont">( ₹{{gwrapAmt}} ) </small>
          </div>
        </div>
        <div class="col-md-4 col-4 text-right">
          <div class="customcheckbox mr-15">
            <input type="checkbox" name="giftwrap" id="giftwrap" v-on:click="applygiftwrap()">
            <label for="" class="mb0">&nbsp;</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  var $ = require('jquery')
  window.jQuery = $
  import {mapGetters} from 'vuex'

  export default {
    props: ['uptotal', 'gwrapAmt', 'usedGwrap', 'upgst'],
    data () {
      return {
        ugiftwrap: this.usedGwrap,
        upsubtotal: this.uptotal,
        gwrapAmount: this.gwrapAmt,
        rwdgst: this.upgst,
        wrapMsg: ''
      }
    },
    methods: {
      applygiftwrap: function () {
        if ($('#giftwrap').is(':checked')) {
          this.axios.post(this.$parent.$parent.domain + 'api/v1/apply-gift-wrap', {}, {
            crossDomain: true,
            withCredentials: true
          }).then((response) => {
            this.ugiftwrap = response.data.giftwrap_amt
            this.upsubtotal = response.data.gstamt.allsubtotal
            this.rwdgst = response.data.gstamt.gstsum
            this.$emit('updateTotal', this.upsubtotal)
            this.$emit('usedwrap', this.ugiftwrap)
            this.$emit('updategst', this.rwdgst)
          }, function (error) {
            console.log(error)
          })
        } else {
          this.axios.post(this.$parent.$parent.domain + 'api/v1/revert-gift-wrap', {}, {
            crossDomain: true,
            withCredentials: true
          }).then((response) => {
            this.ugiftwrap = response.data.giftwrap_amt
            this.upsubtotal = response.data.gstamt.allsubtotal
            this.rwdgst = response.data.gstamt.gstsum
            this.$emit('updateTotal', this.upsubtotal)
            this.$emit('usedwrap', this.ugiftwrap)
            this.$emit('updategst', this.rwdgst)
          }, function (error) {
            console.log(error)
          })
        }
      }
    },
    computed: {
      ...mapGetters({cratWidgets: 'cratWidgets'})
    }
  }
</script>
<style scoped>
  .mr-15 {
    margin-right: -15px;
  }
</style>




// WEBPACK FOOTER //
// cartWidgets.vue?2819725e